import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Runner } from 'protractor';

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  target?: boolean;
  name: string;
  type?: string;
  children?: ChildrenItems[];
}

export interface MainMenuItems {
  state: string;
  short_label?: string;
  main_state?: string;
  target?: boolean;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
}

export interface Menu {
  label: string;
  main: MainMenuItems[];
}

const ADMIN: Menu[] = [
  {
    label: '超级管理员',
    main: [
      {
        state: 'process',
        short_label: 'P',
        name: '流程管理',
        type: 'sub',
        icon: 'ti-control-shuffle',
        children: [
          {
            state: 'main',
            name: '流程管理',
            type: 'sub',
            children: [
              {
                state: 'create',
                name: '创建流程'
              },
              {
                state: 'list',
                name: '流程列表',
                target: false
              }
            ]
          },
          {
            state: 'module',
            name: '模块管理',
            type: 'sub',
            children: [
              {
                state: 'create',
                name: '创建模块'
              },
              {
                state: 'list',
                name: '模块列表',
                target: false
              }
            ]
          },
          {
            state: 'datum',
            name: '节点管理',
            type: 'sub',
            children: [
              {
                state: 'create',
                name: '创建节点'
              },
              {
                state: 'list',
                name: '节点列表',
                target: false
              }
            ]
          }
        ]
      },
      {
        state: 'authority',
        short_label: 'A',
        name: '权限管理',
        type: 'sub',
        icon: 'ti-view-grid',
        children: [
          {
            state: 'account',
            name: '账户管理',
            type: 'sub',
            children: [
              {
                state: 'list',
                name: '列表'
              },
              {
                state: 'create',
                name: '创建'
              }
            ]
          }
        ]
      }
    ]
  }
];
const RUNNER = [
  {
    label: '报建员',
    main: [
      {
        state: 'project',
        short_label: 'P',
        name: '项目管理',
        type: 'sub',
        icon: 'ti-file',
        children: [
          {
            state: 'run',
            name: '报建中'
          }
        ]
      },
    ]
  }
];

const MANAGER = [
  {
    label: '管理员',
    main: [
      {
        state: 'project',
        short_label: 'P',
        name: '项目管理',
        type: 'sub',
        icon: 'ti-file',
        children: [
          {
            state: 'clue',
            name: '线索',
            type: 'sub',
            children: [
              {
                state: 'list',
                name: '列表'
              },
              {
                state: 'history',
                name: '历史',
              }
            ]
          },
          {
            state: 'project',
            name: '项目',
            type: 'sub',
            children: [
              {
                state: 'list',
                name: '列表'
              },
              {
                state: 'create',
                name: '创建'
              }
            ]
          }
        ]
      },
      {
        state: 'authority',
        short_label: 'A',
        name: '权限管理',
        type: 'sub',
        icon: 'ti-view-grid',
        children: [
          {
            state: 'account',
            name: '账户管理',
            type: 'sub',
            children: [
              {
                state: 'list',
                name: '列表'
              },
              {
                state: 'create',
                name: '创建'
              }
            ]
          }
        ]
      }
    ]
  }
];

@Injectable()
export class MenuItems implements CanActivate {
  public static user;
  private oldUser = '';
  private PAGE: Menu[] = [];
  getAll(): Menu[] {
    this.add();
    return this.PAGE;
  }
  getSession() {
    const userSession = sessionStorage.getItem('user');
    if (userSession) {
      return JSON.parse(userSession);
    }
    return undefined;
  }
  add(user?) {
    if (!user) {
      user = this.getSession();
    }
    if (user && this.oldUser !== user) {
      const result = [];
      user.level.forEach(l => {
        switch (+l) {
          case 1:
            user.isAdmin = true;
            result.push(...ADMIN);
            break;
          case 2:
            user.isManager = true;
            result.push(...MANAGER);
            break;
          case 3:
            user.isRunner = true;
            result.push(...RUNNER);
            break;
        }
      });
      MenuItems.user = user;
      sessionStorage.setItem('user', JSON.stringify(user));
      this.PAGE = result;
      this.oldUser = user.id;
    }
  }
  canActivate(router, state) {
    const url = state.url;
    if (!MenuItems.user) {
      MenuItems.user = this.getSession();
    }
    if (MenuItems.user) {
      if (/^\/process/.test(url)) {
        return !!MenuItems.user.isAdmin;
        // 1级管理员页面
      } else if (/^\/project\/run/.test(url)) {
        return !!MenuItems.user.isRunner;
        // 报建员页面
      } else if (/^\/authority/.test(url)) {
        return !!MenuItems.user.isAdmin || !!MenuItems.user.isManager;
      } else if (url === '/authority/account/changePassword') {
        return true;
      } else {
        return !!MenuItems.user.isManager;
        // 管理员页面
      }
    }
    return true;
  }
}



// WEBPACK FOOTER //
// /Users/liyankai/Documents/github/seiya_web.git/src/app/shared/menu-items/menu-items.ts